import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('activity-types', storeModule.createStoreModule('activity-types'))
